import { render, staticRenderFns } from "./ai_config.vue?vue&type=template&id=327341a0&scoped=true"
import script from "./ai_config.vue?vue&type=script&lang=ts"
export * from "./ai_config.vue?vue&type=script&lang=ts"
import style0 from "./ai_config.vue?vue&type=style&index=0&id=327341a0&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "327341a0",
  null
  
)

export default component.exports